/* eslint-disable max-lines-per-function */
import EventClass from "common/utils/ui/event-class";
import { initMobileNavigation as initTransfersNavigation } from "components/masthead/transfers_navigation/component";
import initDrinkwareNavigation from "components/masthead/drinkware_navigation/component";
import { initMobileNavigation as initMadeNavigation } from "components/masthead/made_navigation/component";
import { initMobileNavigation as initSportsNavigation } from "components/masthead/sports_navigation/component";
import "components/masthead/stickers_navigation/component";
import "components/masthead/spangles_navigation/component";
import MobileMenuClass from "./mobile-menu-class";
import MobileMenuVisibilityClass from "./mobile-menu-visibility-class";
import InitHeculesButton from "../mobile-menu-hercules/mobile-menu-hercules";
import "./mobile-menu-banner/mobile-menu-banner.scss";
import "./mobile-menu.scss";

const toggleMasthead = () => {
  const $icons = document.querySelectorAll(".masthead__icon");
  $icons.forEach($icon => $icon.classList.toggle("masthead__icon--hidden"));
};

export default () => {
  const mobileMenu = new MobileMenuClass({
    eventSelector: ".js-mobile-submenu-trigger",
    contentWrapperSelector: ".js-mobile-menu-content",
    bannerWrapperSelector: ".js-mobile-menu-banner",
    menuWrapperSelector: ".js-mobile-menu",
    buttonActiveClass: "mobile-menu__list-button--active",
    submenuActiveClass: "mobile-menu--with-submenu",
    menuScrollContainerSelector: ".js-menu-scroll-container"
  });

  // Initialize the visibility class for the mobile menu
  const menuVisibility = new MobileMenuVisibilityClass({
    menuWrapperSelector: ".js-mobile-menu",
    eventSelector: ".js-masthead-mobile-bar-toggler, .js-masthead-menu-toggler",
    eventCallback: () => {
      toggleMasthead();
      mobileMenu.resetScrollPosition();
      mobileMenu.setDefaultMenu();
    }
  });

  // eslint-disable-next-line no-new
  new EventClass({
    eventSelector: ".js-masthead-mobile-filters-toggler, .js-filters-back",
    eventCallback: () => {
      menuVisibility.closeModal();
    }
  });

  mobileMenu.loadMenu(); // Initial loading menu
  InitHeculesButton();
  initTransfersNavigation();
  initDrinkwareNavigation();
  initMadeNavigation();
  initSportsNavigation();
};
